import _ from 'lodash';

import * as Sentry from '@sentry/browser';

import triageMessage, { TriageStatus, TriageStatusType } from './triageMessage';

const getStatusPostfix = (status: TriageStatusType) =>
  status === TriageStatus.DUPLICATE
    ? ' (deduped)'
    : status === TriageStatus.THROTTLED
    ? ' (throttled)'
    : '';

export const safeCaptureError = (captureFn: any, error: any, options?: any) => {
  const status = triageMessage(_.toString(error.message || error));

  if (status !== TriageStatus.IGNORED) {
    const postfix = getStatusPostfix(status);

    if (error.message) {
      // $FlowFixMe
      error.message += postfix;
    } else {
      // $FlowFixMe
      error += postfix;
    }

    captureFn(error, options);
  }
};

const trackException = (error: any, data: any) => {
  Sentry.withScope(scope => {
    if (data) {
      scope.setExtra('details', data);
    }

    // `error` is an Error object
    if (error.stack) {
      safeCaptureError(Sentry.captureException, error);
      return;
    }

    // `error` is a plain string
    if (_.isString(error)) {
      safeCaptureError(Sentry.captureMessage, error);
      return;
    }

    // `error` is an error response object from our `fetch` module
    if ('status' in error) {
      const message = `${error.status} Response`;

      safeCaptureError(Sentry.captureMessage, message, {
        // stack traces are by default not available when using `captureMessage`.
        // This tells Sentry to attach a synthetic stack trace. See: https://github.com/getsentry/raven-js/pull/582
        stacktrace: true,
        ...data,
        extra: {
          ...data.extra,
          response: {
            type: error.type,
            url: error.url,
          },
        },
      });
      return;
    }

    // We don't know what `error` is. Let's log it and add some extra data to help debug.
    safeCaptureError(
      Sentry.captureMessage,
      `Unknown Object [${_.toString(error)}]`,
      {
        ...data,
        tags: {
          'unknown.object': 'yes', // allows us to find these in Sentry by the `unknown.object` tag
        },
        extra: {
          ...data.extra,
          unknownErrorObject: error,
          // We may not have a stack, so let's try to capture ... something
          stack: new Error('Unknown Object Trace').stack,
        },
      }
    );
  });
};

export { TIME_WINDOW } from './triageMessage';

export default trackException;
